import React from "react";
import { FaDownload } from "react-icons/fa";

async function downloadImage(url) {
  try {
    const response = await fetch(url);
    let contentType = response.headers.get("content-type") || "image/jpeg";
    if (!contentType.startsWith("image/")) contentType = "image/jpeg";
    const blob = await response.blob();
    const typedBlob = blob.type === contentType ? blob : new Blob([blob], { type: contentType });
    const ext = contentType.includes("png") ? "png" : contentType.includes("webp") ? "webp" : "jpg";
    const timestamp = new Date().toISOString().replace(/[:.]/g, "-").slice(0, -5);
    const a = document.createElement("a");
    a.href = window.URL.createObjectURL(typedBlob);
    a.download = `ambaram-source-${timestamp}.${ext}`;
    a.style.display = "none";
    document.body.appendChild(a);
    a.click();
    setTimeout(() => { window.URL.revokeObjectURL(a.href); document.body.removeChild(a); }, 100);
  } catch (err) {
    console.error("Failed to download source image:", err);
  }
}

function SourceImageCard({ url }) {
  return (
    <figure
      style={{ position: "relative", display: "inline-block", margin: 0, overflow: "hidden" }}
      onMouseEnter={(e) => {
        e.currentTarget.querySelector(".source-download-btn").style.opacity = "1";
      }}
      onMouseLeave={(e) => {
        e.currentTarget.querySelector(".source-download-btn").style.opacity = "0";
      }}
    >
      <img
        src={url}
        alt="Source"
        style={{
          width: "150px",
          height: "auto",
          objectFit: "cover",
          borderRadius: "0.6rem",
        }}
      />
      <div style={{
        position: "absolute",
        top: "0.3rem",
        left: "0.3rem",
        backgroundColor: "rgba(0, 0, 0, 0.65)",
        color: "white",
        padding: "1px 6px",
        borderRadius: "4px",
        fontSize: "0.7rem",
        fontWeight: "600",
        letterSpacing: "0.03em",
      }}>
        Source
      </div>
      <div
        className="source-download-btn"
        onClick={() => downloadImage(url)}
        style={{
          position: "absolute",
          top: "0.5rem",
          right: "0.5rem",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          width: "36px",
          height: "36px",
          borderRadius: "50%",
          backgroundColor: "rgba(0, 0, 0, 0.6)",
          backdropFilter: "blur(8px)",
          WebkitBackdropFilter: "blur(8px)",
          cursor: "pointer",
          boxShadow: "0 2px 8px rgba(0, 0, 0, 0.3)",
          opacity: 0,
          transition: "opacity 0.3s ease-in-out",
        }}
        onMouseEnter={(e) => {
          e.currentTarget.style.backgroundColor = "rgba(0, 0, 0, 0.8)";
          e.currentTarget.style.transform = "scale(1.1)";
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.backgroundColor = "rgba(0, 0, 0, 0.6)";
          e.currentTarget.style.transform = "scale(1)";
        }}
      >
        <FaDownload style={{ fontSize: "1.3rem", color: "white", filter: "drop-shadow(0 1px 2px rgba(0,0,0,0.8))" }} />
      </div>
    </figure>
  );
}

export default SourceImageCard;
